import React from 'react';

import DateCell from '../CellTypes/DateCell';
import SelectCell from '../CellTypes/SelectCell';
import ListCell from '../CellTypes/ListCell';
import LinkCell from '../CellTypes/LinkCell';
import ContentCell from '../CellTypes/ContentCell';
import TextCell from '../CellTypes/TextCell';

import formatUtils from './formatters';

import { DATA_FORMAT_TYPES } from '../../../../constants';

class CellFactory {
    static CELL_COMPONENT = {
        [DATA_FORMAT_TYPES.LOCAL_DATE]: {
            Component: DateCell,
            formatter: formatUtils.toLocalDate
        },
        [DATA_FORMAT_TYPES.LOCAL_DATE_TIME]: {
            Component: DateCell,
            formatter: formatUtils.toLocalDateTime
        },
        [DATA_FORMAT_TYPES.DATE]: {
            Component: DateCell,
            formatter: formatUtils.toEasternDate
        },
        [DATA_FORMAT_TYPES.DATE_TIME]: {
            Component: DateCell,
            formatter: formatUtils.toEasternDateTime
        },
        [DATA_FORMAT_TYPES.SELECT]: {
            Component: SelectCell
        },
        [DATA_FORMAT_TYPES.LIST]: {
            Component: ListCell
        },
        [DATA_FORMAT_TYPES.LINK]: {
            Component: LinkCell
        },
        [DATA_FORMAT_TYPES.CONTENT]: {
            Component: ContentCell
        },
        [DATA_FORMAT_TYPES.TEXT]: {
            Component: TextCell
        }
    };

    static createCell({
        value,
        className,
        headerName,
        dataFormat,
        cellColProps,
        cellExtraProps
    }) {
        if (!dataFormat) {
            dataFormat = value !== Object(value)
                ? DATA_FORMAT_TYPES.TEXT
                : DATA_FORMAT_TYPES.CONTENT;
        }

        const { Component, formatter } = CellFactory.CELL_COMPONENT[dataFormat];

        return (
            <Component
                value={formatter ? formatter(value) : value}
                className={className}
                headerName={headerName}
                colProps={cellColProps}
                extraProps={cellExtraProps}
            />
        );
    }
}

export default CellFactory;
